import { ExternshipDocumentSlot } from "@platform-app/app/core/api/models";

export class LoadPlacementExternshipDocuments {
  static readonly type =
    "[Externship Documents] Load Placement Externship Documents";
  constructor(public payload: { placementId: string }) {}
}

export class LoadStudentExternshipDocuments {
  static readonly type =
    "[Externship Documents] Load Student Externship Documents";
  constructor(public payload: { studentId: string }) {}
}

export class UploadExternshipDocument {
  static readonly type = "[Externship Documents] Upload Externship Document";
  constructor(public payload: { slot: ExternshipDocumentSlot; file: Blob }) {}
}

export class DeleteExternshipDocument {
  static readonly type = "[Externship Documents] Delete Externship Document";
  constructor(public payload: { slot: ExternshipDocumentSlot }) {}
}

export class ResetExternshipDocuments {
  static readonly type = "[Externship Documents] Reset Externship Documents";
}
